import { general } from './general';
import { collection } from './collection';
import { branch } from './branch';
import { name } from './name';
import { location } from './location';
import { country } from './country';
import { textarea } from './textarea';
import { checkbox } from './checkbox';
import { radio } from './radio';
import { notapplicable } from './notapplicable';

export const coowners = (data = {}) => general('coowners', {
  List: collection(
    ((data.List || {}).items || []).map((y) => {
      const yitem = y.Item || {};
      return {
        Item: {
          Has: branch(yitem.Has),
          Name: name(yitem.Name),
          Address: location(yitem.Address),
          Countries: country(yitem.Countries),
          RelationshipNature: textarea(yitem.RelationshipNature),
          // pvq
          CoOwnerTypeOtherExplanation: textarea(yitem.CoOwnerTypeOtherExplanation),
           CoOwnerType: radio(yitem.CoOwnerType),
           RelationshipNotApplicable: notapplicable(yitem.RelationshipNotApplicable),
          CountryNotApplicable: notapplicable(yitem.CountryNotApplicable),
          AddressNotApplicable: notapplicable(yitem.AddressNotApplicable),
          InUsNotApplicable: notapplicable(yitem.InUsNotApplicable),
          Relationship: radio(yitem.Relationship),
        },
      };
    })
  ),
});
